import { render } from "./role_master.vue?vue&type=template&id=8013ab92&scoped=true"
import script from "./role_master.vue?vue&type=script&lang=js"
export * from "./role_master.vue?vue&type=script&lang=js"

import "./role_master.vue?vue&type=style&index=0&id=8013ab92&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Tracker Eticket\\Tracker_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8013ab92"]])

export default __exports__